<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Detalle Asiento</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Debito</th>
          <th scope="col">Credito</th>
          <th scope="col">Referencia</th>
          <th scope="col">AsientoFechaReg</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="asientodet in datosPaginados" :key="asientodet.idAsientoDet">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(asientodet.idAsientoDet)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(asientodet.idAsientoDet)" title="Editar">edit_square</i></td>
          <td>{{asientodet.debito}}</td>
          <td>{{asientodet.credito}}</td>
          <td>{{asientodet.referencia}}</td>
          <td>{{getFormattedDate(asientodet.asientoFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAsientoDet(asientodet.idAsientoDet)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAsientoDet" class="form-label">IdAsientoDet</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAsientoDet" name="idAsientoDet" v-model="datoAsientoDet.idAsientoDet" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Asiento -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAsiento" class="form-label"> Asiento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAsiento" name="idAsiento" v-model="datoAsientoDet.idAsiento">
                      <option v-for="asiento in asientos" :value="asiento.idAsiento" :key="asiento.idAsiento">
                        {{ asiento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Asiento -->
<!-- Botón Lista de Valores  Cuenta -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idCuenta" class="form-label"> Cuenta</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idCuenta" name="idCuenta" v-model="datoAsientoDet.idCuenta">
                      <option v-for="cuenta in cuentas" :value="cuenta.idCuenta" :key="cuenta.idCuenta">
                        {{ cuenta.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Cuenta -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="debito" class="form-label">Débito</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="debito" name="debito" v-model="datoAsientoDet.debito" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="credito" class="form-label">Crédito</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="credito" name="credito" v-model="datoAsientoDet.credito" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="referencia" class="form-label">Referencia</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="referencia" name="referencia" v-model="datoAsientoDet.referencia" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAsientoDet" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAsientoDet" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      asientodets : [],
      datoAsientoDet : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      asientos: [],
      cuentas: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchAsientos()
    this.fetchCuentas()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.asientodets.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwasientodets/nombre/'+this.nombreBusqueda).then(response=>{
          this.asientodets=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.asientodets.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwasientodets').then(response=>{
      this.asientodets=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.asientodets.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idAsiento'
        ,'idCuenta'
        ,'debito'
        ,'credito'
        ,'referencia'
      ];
      const requiredFieldsText = [
        'idAsiento'
        ,'idCuenta'
        ,'debito'
        ,'credito'
        ,'referencia'
      ];
      return validarForm(this.datoAsientoDet, requiredFields, requiredFieldsText);
    },
    async guardarAsientoDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/asientodets', this.datoAsientoDet)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AsientoDet creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAsientoDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/asientodets', this.datoAsientoDet)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AsientoDet creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAsientoDet={}
      this.titulo   = 'Crear Detalle Asiento'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idAsientoDet){
      this.modalWindow = true
      if(idAsientoDet != null){    
           api.get('/vwasientodets/'+idAsientoDet).then(resp=>{
          this.datoAsientoDet = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Detalle Asiento'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idAsientoDet){
      if(idAsientoDet != null){
        this.$router.push('/asientodetmd/'+idAsientoDet)
      }
    },
    async deleteAsientoDet (idAsientoDet) {
      try{
        await api.delete('/asientodets/'+idAsientoDet)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchAsientos() {
      fetch('http://localhost:8080/api/v1/asientos')
        .then(response => response.json())
        .then(data => {
          this.asientos = data;
        })
        .catch(error => {
          console.error('Error fetching asientos:', error);
        });
    },
    fetchCuentas() {
      fetch('http://localhost:8080/api/v1/cuentas')
        .then(response => response.json())
        .then(data => {
          this.cuentas = data;
        })
        .catch(error => {
          console.error('Error fetching cuentas:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
